<div class="open-modal" (click)="openFullscreen(ifr)">
  <iframe class="frame" src="https://viennaairport.panomax.com" style="width: 300px; height: 200px; border: none; pointer-events: none" allowfullscreen #ifr></iframe>
</div>
